import { NoticeConfigurationPage } from "features/fund-family/configuration/notices/NoticeConfigurationPage";
import { getNoticeConfigRetrieveLoader } from "gen/endpoints/notice-config/notice-config";
import { getNoticeDocumentTemplateRetrieveLoader } from "gen/endpoints/notice-document-template/notice-document-template";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

export const fundFamilyConfigurationNoticeRoutes: RouteObject = {
  id: "fundFamilyConfigurationNotices",
  path: "notices",
  handle: {
    showSidebar: true,
  },
  element: <NoticeConfigurationPage />,
  children: [
    {
      id: "setupNotices",
      lazy: async () => {
        const { FundFamilyConfigurationNoticesPage } = await import(
          "features/fund-family/configuration/notices/FundFamilyConfigurationNoticesPage"
        );
        return { Component: FundFamilyConfigurationNoticesPage };
      },
      children: [
        {
          id: "setupNoticesSchema",
          path: "",
          lazy: async () => {
            const { FundFamilyConfigurationNoticesTabSchema } = await import(
              "features/fund-family/configuration/notices/FundFamilyConfigurationNoticesTabSchema"
            );
            return { Component: FundFamilyConfigurationNoticesTabSchema };
          },
          handle: {
            title: i18n.t("notices:schema"),
          },
        },
        {
          id: "setupNoticesConfig",
          path: "config",
          lazy: async () => {
            const { FundFamilyConfigurationNoticesTabConfig } = await import(
              "features/fund-family/configuration/notices/FundFamilyConfigurationNoticesTabConfig"
            );
            return { Component: FundFamilyConfigurationNoticesTabConfig };
          },
          loader: composeLoaders(getNoticeConfigRetrieveLoader()),
          handle: {
            title: i18n.t("common:configuration"),
          },
        },
        {
          id: "setupNoticesCapitalCall",
          path: "capital-call",
          lazy: async () => {
            const { FundFamilyConfigurationNoticesTabCapitalCall } =
              await import(
                "features/fund-family/configuration/notices/FundFamilyConfigurationNoticesTabCapitalCall"
              );
            return { Component: FundFamilyConfigurationNoticesTabCapitalCall };
          },
          loader: composeLoaders(
            getNoticeDocumentTemplateRetrieveLoader({
              event_type: "capital_call",
            }),
          ),
          handle: {
            title: i18n.t("common:capitalCall"),
          },
        },
        {
          id: "setupNoticesDistribution",
          path: "distribution",
          lazy: async () => {
            const { FundFamilyConfigurationNoticesTabDistributions } =
              await import(
                "features/fund-family/configuration/notices/FundFamilyConfigurationNoticesTabDistributions"
              );
            return {
              Component: FundFamilyConfigurationNoticesTabDistributions,
            };
          },
          loader: composeLoaders(
            getNoticeDocumentTemplateRetrieveLoader({
              event_type: "distribution",
            }),
          ),
          handle: {
            title: i18n.t("common:distribution"),
          },
        },
      ],
    },
  ],
};
